import type { UnknownOutputParams } from 'expo-router'
import type { ReactNode } from 'react'

import { ShareSearchParamsAction } from '@/src/features/share/ui/components/ShareSearchParamsAction'
import { TRACKING_SOURCE } from '@/src/general/utils/gtm/constants'

import { CommunityShareModal, type TCommunityShareModalProps } from '../../components/CommunityShareModal'

type TCommunitySearchParamsShareProps = Omit<TCommunityShareModalProps, 'children' | 'trackingSource'> & {
  searchParams: UnknownOutputParams
}

export const CommunitySearchParamsShare = ({
  searchParams,
  ...otherProps
}: TCommunitySearchParamsShareProps): ReactNode => (
  <CommunityShareModal trackingSource={TRACKING_SOURCE.EMAIL_LINK} {...otherProps}>
    {({ onShare }) => <ShareSearchParamsAction onShare={onShare} searchParams={searchParams} />}
  </CommunityShareModal>
)
